require('./baseState.js');

(function(){
  Pegasus.InitializingState = Pegasus.BaseState.extend({
    setup: function(manager, params){
      var launchController = Pegasus.lookupController('launchPlatform');
      if ( launchController.get('isRetrieveComplete') ){
        Pegasus.lookupRouter().send('loadTemplate');
        return;
      }

      Pegasus.Helpers.addOneTimeObserver(launchController, 'isRetrieveComplete', true, function(){
        Em.run.scheduleOnce('afterRender', Pegasus.lookupRouter(), 'send', 'loadTemplate');
      });
    },
    contentInitialized: function(manager, params){
      Pegasus.lookupRouter().send('showTemplate', params);
      Em.run.scheduleOnce('afterRender', this, 'completeTransition');
    },
    completeTransition: function(){
      this.transitionToIdle();
    },
    transitionToPreview: function(){
      Pegasus.loadedTemplate().set('previewContent', Pegasus.canvasInstance.mutateForOut().message );
      Pegasus.lookupRouter().send('showPreview', Pegasus.lookupController('preview').get('content'));
    },
    transitionToIdle: function(){
      Pegasus.stateMachine.transitionTo('idling');
    }
  });
})();
